export const NAME = 'casesReceipt';